/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tab from "vux/src/components/tab/tab.vue"; // this line is trasformed by vux-loader
import TabItem from "vux/src/components/tab/tab-item.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import PopupHeader from "vux/src/components/popup-header/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import { getAreaList as _getAreaList, getAreaInfo } from '@/api';
export default {
  name: 'TAddressOnline',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    address: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    level: {
      type: Number,
      default: 4,
      validator: function validator(n) {
        return [1, 2, 3, 4].includes(n);
      }
    }
  },
  directives: {
    TransferDom: TransferDom
  },
  components: {
    Tab: Tab,
    TabItem: TabItem,
    Popup: Popup,
    PopupHeader: PopupHeader
  },
  mounted: function mounted() {},
  computed: {
    active: function active() {
      return this.selectedValue.length ? this.selectedValue.length - 1 : 0;
    },
    realList: function realList() {
      var _this = this;
      return [{
        data: this.areaJson
      }, {
        data: this.cityData
      }, {
        data: this.districtData
      }, {
        data: this.streetData
      }].filter(function (_, i) {
        return i < _this.level;
      });
    },
    adsLevel: function adsLevel() {
      var _this2 = this;
      return [i18n.tc("493"), i18n.tc("494"), i18n.tc("495"), i18n.tc("496")].filter(function (_, i) {
        return i < _this2.level;
      });
    },
    currValue: {
      get: function get() {
        var _this3 = this;
        if (this.address.length) {
          this.$nextTick(function () {
            _this3.setPositon();
          });
        }
        // fix滚动穿透
        if (this.value) {
          document.body.classList.add('no-scroll');
        } else {
          document.body.classList.remove('no-scroll');
        }
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    }
  },
  watch: {
    selectedValue: {
      handler: function handler() {
        var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        if (array[0]) {
          this.getAreaList(array[0].id, 'cityData');
        } else {
          this.cityData = [];
        }
        if (array[1]) {
          this.getAreaList(array[1].id, 'districtData');
        } else {
          this.districtData = [];
        }
        if (array[2]) {
          this.getAreaList(array[2].id, 'streetData');
        } else {
          this.streetData = [];
        }
      },
      deep: true
    },
    address: function address(v) {
      if (v.length) {
        this.getAddressName();
      }
    }
  },
  data: function data() {
    return {
      selectedValue: [],
      areaJson: [],
      cityData: [],
      districtData: [],
      streetData: []
    };
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.getAreaList(1, 'areaJson');
            case 2:
              if (!_this4.address.length) {
                _context.next = 5;
                break;
              }
              _context.next = 5;
              return _this4.getAddressName();
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getAddressName: function getAddressName() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var ids, _yield$getAreaInfo, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ids = _this5.address.filter(Boolean).join(',');
                _context2.next = 3;
                return getAreaInfo({
                  ids: ids
                });
              case 3:
                _yield$getAreaInfo = _context2.sent;
                data = _yield$getAreaInfo.data;
                _this5.selectedValue = data;
                _this5.$emit('show-name', _this5.selectedValue.map(function (v) {
                  return v.name;
                }));
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getAreaList: function getAreaList(id, list) {
      var _this6 = this;
      return _getAreaList({
        parentId: id
      }).then(function (_ref) {
        var success = _ref.success,
          data = _ref.data;
        if (success) {
          _this6[list] = data;
        } else {
          _this6[list] = [];
        }
      });
    },
    rigthClick: function rigthClick() {
      this.currValue = false;
      this.$emit('on-change', this.selectedValue.map(function (v) {
        return v.id;
      }), this.selectedValue.map(function (v) {
        return v.name;
      }));
    },
    setPositon: function setPositon() {
      var _this7 = this;
      this.selectedValue.forEach(function (v, i) {
        if (v && v.id) {
          var index = _this7.realList[i].data.findIndex(function (value) {
            return value.id === v.id;
          });
          _this7.$refs['area-list'][i].scroll(0, 32 * index);
        }
      });
    },
    click: function click(area) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (this.selectedValue.length - 1 > type) {
        this.selectedValue.splice(type, this.selectedValue.length - type, area);
      } else {
        this.$set(this.selectedValue, type, area);
      }
    },
    saveData: function saveData() {
      this.$emit('on-change', this.selectedValue.map(function (v) {
        return v.id;
      }));
    }
  }
};